import { render } from "./suggestion-chips.vue?vue&type=template&id=56584a4c&scoped=true"
import script from "./suggestion-chips.vue?vue&type=script&lang=js"
export * from "./suggestion-chips.vue?vue&type=script&lang=js"

import "./suggestion-chips.vue?vue&type=style&index=0&id=56584a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56584a4c"]])

export default __exports__